<template>
	<div class="org_class">
		<filterbar s_name="班级" @searchName="setSearchName" @school_search="setSchool_search"
			@dept_search="setDept_search" @major_search="setMajor_search" :getSchoolArray="getSchoolArray"
			:getDeptArray="getDeptArray" :getMajorArray="getMajorArray">
		</filterbar>
		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>班级列表({{tableDataCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="dialogEdit = true"
					v-if="getUserInfo.roleID>1">添加班级
				</el-button>
			</div>
			<el-table :data="showDate()">
				<el-table-column fixed type="index" width="50" align="center">
					<template slot-scope="scope">
						{{(page_current-1)*page_size+scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column label="学校名称" align="left">
					<template slot-scope="scope">
						{{showSchoolName(scope.row.schoolId)}}
					</template>
				</el-table-column>
				<el-table-column label="学院名称" align="left">
					<template slot-scope="scope">
						{{showDeptName(scope.row.deptId)}}
					</template>
				</el-table-column>
				<el-table-column label="专业名称" align="left">
					<template slot-scope="scope">
						{{showMajorName(scope.row.majorId)}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="班级名称" align="left"> </el-table-column>
				<el-table-column label="关联教师" align="center" v-if="getUserInfo.roleID!=4">
					<template slot-scope="scope">
						{{scope.row.classTeachers?scope.row.classTeachers.length:0}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column fixed="right" label="操作" align="center" width="300">
					<template slot-scope="scope">
						<!-- 关联教师 -->
						<el-button icon="el-icon-s-custom" size="mini"
							@click="classID=scope.row.id;dialogClassTeacher = true" v-if="getUserInfo.roleID!=4">关联教师
						</el-button>
						<!-- 编辑 -->
						<el-button icon="el-icon-edit" style="margin-right: 10px;" size="mini"
							@click="dialogEdit2_data = scope.row; dialogEdit2 = true">编辑</el-button>
						<!-- 删除 -->
						<el-popconfirm confirm-button-text='确认' cancel-button-text='取消' icon="el-icon-info"
							icon-color="red" title="确定删除吗？" @confirm="del(scope.row.id)">
							<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除
							</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<class-edit type="add" title="添加班级" :dialogVisible="dialogEdit" @before-close="dialogEdit=false;loadData()"
			:getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray" :getMajorArray="getMajorArray"
			:getClassArrayName="getClassArray" v-if="dialogEdit"></class-edit>
		<class-edit type="update" title="编辑班级" :dialogVisible="dialogEdit2" @before-close="dialogEdit2=false;loadData()"
			:obj="dialogEdit2_data" :getSchoolArray="getSchoolArray" :getDeptArray="getDeptArray"
			:getMajorArray="getMajorArray" :getClassArrayName="getClassArray"></class-edit>
		<!-- 设置关联教师 -->
		<classTeacher :dialogVisible="dialogClassTeacher" :classID='classID'
			@before-close="dialogClassTeacher=false;loadData()">
		</classTeacher>
	</div>
</template>

<script>
	import classEdit from './class/edit'
	import classTeacher from './class/classTeacher'
	import filterbar from '@/components/org-filterbar/filterbar3.vue'

	import {
		mapGetters
	} from 'vuex'

	export default {
		name: 'dept',
		data() {
			return {
				page_size: 10,
				page_current: 1,
				tableDataCount: 0,
				search_name: '',
				search_school: '',
				search_dept: '',
				search_major: '',
				dialogEdit: false,
				dialogEdit2: false,
				dialogEdit2_data: null,
				disabled: false,
				disabled_dept: false,
				getSchoolArray: [],
				getDeptArray: [],
				getMajorArray: [],
				getClassArray: [],
				dialogClassTeacher: false,
				classID: ''
			}
		},
		created() {
			this.loadData()
		},
		components: {
			classEdit,
			filterbar,
			classTeacher
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		methods: {
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e

			},
			showDate() {
				let _data = this.getClassArray
					.filter(item => item.name &&
						item.name.search(this.search_name) > -1 &&
						(item.schoolId + '').search(this.search_school) > -1 &&
						(item.deptId + '').search(this.search_dept) > -1 &&
						(item.majorId + '').search(this.search_major) > -1)
				this.tableDataCount = _data.length
				return _data.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
			},
			showDept(search_school) {
				return this.getDeptArray.filter(item => {
					return item.schoolId.search(this.search_school) > -1
				})
			},
			showMajor() {
				return this.getMajorArray.filter(item => {
					return item.deptID.search(this.search_dept) > -1
				})
			},
			setSearchName(val) {
				this.search_name = val
				this.page_current = 1
			},
			setSchool_search(val) {
				this.search_school = val
				this.page_current = 1
			},
			setDept_search(val) {
				this.search_dept = val
				this.page_current = 1
			},
			setMajor_search(val) {
				this.search_major = val
				this.page_current = 1
			},
			showSchoolName(val) {
				let school = this.getSchoolArray.find(item => {
					return item.id == val
				})
				if (school) {
					return school.name
				}
				return ''
			},
			showDeptName(val) {
				let dept = this.getDeptArray.find(item => {
					return item.id == val
				})
				if (dept) {
					return dept.name
				}
				return ''
			},
			showMajorName(val) {
				let major = this.getMajorArray.find(item => {
					return item.id == val
				})
				if (major) {
					return major.name
				}
				return ''
			},
			del(id) {
				this.$http.get('api/org/DelClass/' + id).then(res => {
					this.loadData()
				})
			},
			async loadData() {
				await this.$http.get('api/org/GetSchools').then(res => {
					this.getSchoolArray = res.data.data
				})
				await this.$http.get('api/org/GetDept/').then(res => {
					this.getDeptArray = res.data.data
				})
				await this.$http.get('api/org/GetMajor/').then(res => {
					this.getMajorArray = res.data.data
				})
				await this.$http.get('api/org/GetClass').then(res => {
					if (res.data.code == 1) {
						this.getClassArray = res.data.data.sort((a, b) => {
							return a.createTime < b.createTime
						})

						if (this.getUserInfo.roleID == 4) {
							this.getClassArray = this.getClassArray.filter(item => {
								let ctitem = item.classTeachers.find(ct => ct.teacherID == this
									.getUserInfo.id)
								if (ctitem) {
									return item
								}
							})
						}

					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.org_class{
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
